Hop.defineModule('input-validation', (domRoot) => {
    const inputsToCheck = domRoot.querySelectorAll('.js-input-to-verify');

    function addGtmTrackingToEachInput(isValidatedInput, input) {
        const gtmObjectTracking = JSON.parse(input.querySelector('.js-input-to-verify').getAttribute('data-gtm'));

        if (isValidatedInput && !input.querySelector('[data-gtm-sent-event]')) {
            Hop.gtm.push(gtmObjectTracking);
        }
    }

    function radioButtonAndCheckboxValidator(input) {
        const allCheckbox = domRoot.querySelectorAll(`[name="${input.name}"]:checked`);
        return allCheckbox.length >= 1;
    }

    function selectOptionValidator(input) {
        return input.value !== '';
    }

    function inputTextValidator(input) {
        let isInputLengthBiggerThanMinlength = null;

        if (input.minLength !== -1) {
            isInputLengthBiggerThanMinlength = input.value.length > input.minLength;
        } else {
            isInputLengthBiggerThanMinlength = input.value.length === Number(input.getAttribute('data-type'));
        }

        const isInputContentEmpty = input.value !== '';

        if (input.minLength !== -1) {
            isInputLengthBiggerThanMinlength = input.value.length > input.minLength;
            return isInputLengthBiggerThanMinlength;
        } else if (input.getAttribute('data-type')) {
            isInputLengthBiggerThanMinlength = input.value.length === Number(input.getAttribute('data-type'));
            return isInputLengthBiggerThanMinlength;
        } else {
            return isInputContentEmpty;
        }
    }

    function inputEmailValidator(input) {
        if (input.value.includes('@') && input.value.includes('.') && input.value.match(/@/g).length === 1) {
            return input.value.includes('@') && input.value.includes('.');
        }
    }

    function textareaValidator(input) {
        return input.value !== '';
    }

    function displayCheckIconIfInputIsValid(isInputValidated, validatedInputWrapper) {
        if (isInputValidated) {
            validatedInputWrapper.classList.add('validated-field-icon');
            validatedInputWrapper.querySelector('.js-input-to-verify').setAttribute('data-gtm-sent-event', '');
        } else {
            validatedInputWrapper.classList.remove('validated-field-icon');
        }
    }

    const inputTypeListenerMap = {
        'text': inputTextValidator,
        'email': inputEmailValidator,
        'radio': radioButtonAndCheckboxValidator,
        'checkbox': radioButtonAndCheckboxValidator,
        'select-one': selectOptionValidator,
        'textarea': textareaValidator,
    };

    function updateInputValidationState(currentInput) {
        const isInputValidated = inputTypeListenerMap[currentInput.type](currentInput);
        const validatedInputWrapper = currentInput.closest('.js-input-validated-wrapper');

        addGtmTrackingToEachInput(isInputValidated, validatedInputWrapper);
        displayCheckIconIfInputIsValid(isInputValidated, validatedInputWrapper);
    }

    function handleEventListenerAndUpdateUI(input) {
        input.addEventListener('input', (e) => {
            const currentInput = e.target;
            const inputTypeListener = inputTypeListenerMap[currentInput.type];

            if (inputTypeListener) {
                updateInputValidationState(currentInput);
            }
        });
    }

    function listenToUserActions() {
        inputsToCheck.forEach((input) => {
            updateInputValidationState(input);
            handleEventListenerAndUpdateUI(input);
        });
    }

    listenToUserActions();
});
